( function( $, document, window ) {
    'use strict';

    $( function() {
        window.fixBody = function() {
            var scrollPos = $( window ).scrollTop();

            $( 'body' ).css( {
                'overflow' : 'hidden',
                'position' : 'fixed',
                'top' : '-' + scrollPos + 'px',
                'width' : '100%'
            } );
        };

        window.unfixBody = function() {
            var $body = $( 'body' );
            var top = $body.css( 'top' );

            $body.css( {
                'overflow' : '',
                'position' : '',
                'top' : '',
                'width' : ''
            } );

            $( window ).scrollTop( parseInt( top || '0' ) * -1 );
        };
    } );
} )( jQuery, document, window );


jQuery(document).ready(function($) {
    var $selectBox          = $('.jsSelectBox');
    var $selectBoxOptions   = $selectBox.find('.jsOptions');
    var $selectedOption     = $selectBox.find('.jsSelected');
    var $helpSubmitButton   = $('.jsHelpSubmit');

    $selectBox.on('click' , function() {
        $selectBoxOptions.toggleClass('open');
    });

    $selectBoxOptions.find('.option').each( function() {
        var $this = $(this);
        var value = $this.attr('data-value');
        var label = $this.text();

        $this.on('click' , function() {
            $selectedOption.text(label);
            $helpSubmitButton.attr('href' , value);
        });
    });

    var $heroSlider = $('.jsHeroSlider');
    if( $heroSlider.length > 0 ) {
        $heroSlider.owlCarousel({
            items: 1,
            dots: false,
            nav: false,
            autoplay:true,
            autoplayTimeout:5000,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            autoplayHoverPause:true,
            loop: true
        });
    }
    var $heroPrevButton = $( '.js-hero-carousel-button-prev' );
    var $heroNextButton = $( '.js-hero-carousel-button-next' );

    $heroPrevButton.on( 'click', function() {
        $heroSlider.trigger( 'prev.owl.carousel' );
    } );

    $heroNextButton.on( 'click', function() {
        $heroSlider.trigger( 'next.owl.carousel' );
    } );

    var $sliderStyle1Wrapper = $('.jsSliderType1Wrapper');

    if( $sliderStyle1Wrapper.length > 0 ) {

        var $style1Sliders = $sliderStyle1Wrapper.find('.owl-carousel');

        $style1Sliders.each( function() {
            var $this   = $(this);
            var items   = $(this).attr('data-slides') ? $(this).attr('data-slides') : 4;
            var itemsLG = $(this).attr('data-slides-lg') ? parseInt($(this).attr('data-slides-lg')) : 3;
            var itemsMD2 = $(this).attr('data-slides-md2') ? parseInt($(this).attr('data-slides-md2')) : 2;
            var itemsMD = $(this).attr('data-slides-md') ? parseInt($(this).attr('data-slides-md')) : 2;
            var itemsSM = $(this).attr('data-slides-sm') ? parseInt($(this).attr('data-slides-sm')) : 1;
            var margin  = $(this).attr('data-margin') ? parseInt($(this).attr('data-margin')) : 40;
            var padding = $(this).attr('data-padding') ? parseInt($(this).attr('data-padding')) : 40;

            $this.owlCarousel({
                loop:true,
                stagePadding: padding,
                margin:10,
                nav:false,
                dots: true,
                responsive:{
                    0:{
                        stagePadding: 20,
                        items:itemsSM
                    },
                    600:{
                        items:itemsMD,
                        stagePadding: 20
                    },
                    768: {
                        items: itemsMD2,
                        stagePadding: 20,
                        loop: false,
                    },
                    1000:{
                        margin: 20,
                        items:itemsLG,
                        stagePadding: 30,
                        loop: false
                    },
                    1300:{
                        margin: margin,
                        items: items,
                        loop: false,
                        stagePadding: 30
                    }
                }
            });
        });
    }





    var $sliderStyle2Wrapper = $('.jsSliderType2Wrapper');

    if( $sliderStyle2Wrapper.length > 0 ) {

        var $style2Sliders = $sliderStyle2Wrapper.find('.owl-carousel');

        $style2Sliders.each( function() {
            var $this   = $(this);

            $this.owlCarousel({
                loop:true,
                stagePadding: 0,
                margin: 10,
                nav: false,
                dots: true,
                responsive: {
                    0: {
                        stagePadding: 20,
                        items: 1
                    },
                    600: {
                        items:2,
                        stagePadding: 20
                    },
                    768: {
                        items: 3,
                        stagePadding: 20,
                        loop: false,
                    },
                    1024: {
                        margin: 20,
                        items: 2,
                        stagePadding: 0,
                        loop: false
                    },
                    1300: {
                        margin: 30,
                        items: 3,
                        loop: false,
                        stagePadding: 0
                    }
                }
            });
        });
    }






    if( $('.latest-news-slider').length > 0 ) {

      $('.latest-news-slider').each( function() {

          var $this = $(this);

          $this.owlCarousel({
              loop:	false,
              nav: 	false,
              dots: true,
              responsive:{
                  0:{
                      items:1,
                      margin: 20,
                  },
                  600: {
                      margin: 20,
                      items:2
                  },
                  1024:{
                      margin: 20,
                      items: 3,
                  },
                  1300: {
                    margin: 40,
                    items: 3,
                  }
              }
          });
      });
  }

    $('.card').on('click' , '.jsCardTrigger' , function(e) {
        e.preventDefault();
        $(this).parents('.card').toggleClass('active');
    });

    var $mobileMenu    = $('#mobile-menu');
    var $mobileSubmenu = $('#mobile-menu .menu-item-has-children');
    $mobileSubmenu.each( function(){

        var $this = $(this);
        var $submenuToggle = $this.find('.jsSubMenuTrigger').first();
        var $submenu       = $this.find('.submenu').first();

        $submenuToggle.on('click', function(){
            var $this = $(this);
            $this.toggleClass('active');

            $submenu.slideToggle('fast');

        });
    });

    // $('.burger-menu-wrapper').on('click' , function() {
    //     $('body').toggleClass('mobile-menu');
    // });

    $('.scroll-down-btn').on('click' , function(e) {
        e.preventDefault();

        var offset = $($(this).attr('data-scrolls')).offset().top;
        $('html, body').animate({scrollTop: offset} , 'slow');
    });

    var $accordionWrapper = $('.accordion-wrapper');

    var $accordionItems = $accordionWrapper.find('.accordion-item');

    $accordionItems.each( function() {
        var $this = $(this);
        var $head = $this.find('.accordion-head');
        var $body = $this.find('.accordion-body');

        $head.on('click' , function() {
            $body.slideToggle('fast');
            $this.toggleClass('active');
        });
    });

    var $sidebarHeads = $('.service-sidebar.mobile .sidebar-widget.accordion h3');

    $sidebarHeads.each(function(){
        var $this = $(this);
        var $slideContent = $this.next('ul');

        $this.on('click', function() {
            $this.toggleClass('active');
            $slideContent.slideToggle('fast');
        });
    });

    if( $('.service-sidebar').length > 0 ) {

        // registerWaypoints();

        $('.service-sidebar.desktop').stick_in_parent({
            inner_scrolling: false,
            offset_top: 10
        });

        var $sidebarNavMobile =  $('.sidebar-mobile-top');

        $sidebarNavMobile.find('a').on('click' , function(){
            // $(this).parents('.sidebar-widget').find('h3.active').removeClass('active');
            // $(this).parents('ul').slideToggle('fast');
        });

        $sidebarNavMobile.stick_in_parent({
            parent: '.row',
            inner_scrolling: false,
            offset_top: 0
        });

        var $jumpLink = $('.jsJumpSectionLink');
    
        $jumpLink.on('click' , function(e) {
            e.preventDefault();
            var target = $(this).attr('href');

            $(this).parents('.sidebar-widget').find('h3.active').removeClass('active');
            $('.sidebar-widget.accordion').find('ul').slideToggle('fast', function() {
                $('html , body').animate({
                    scrollTop: ( $(target).offset().top )
                } , 500);
            } );
        });  
    }

    function highlightMenuItem( id ) {
        var $sectionMenuItem = $('.service-sidebar.mobile');
        var currentClassName = 'selected';

        if ( 'undefined' !== typeof id && '' !== id ) {
            var $sectionMenuLink = $sectionMenuItem.find( 'a[href="#' + id + '"]' );

            if ( $sectionMenuLink.length ) {
                $sectionMenuItem.find('a').removeClass( currentClassName );
                $sectionMenuLink.addClass( currentClassName );
                $sidebarNavMobile.find( '.nav-toggle' ).text( $sectionMenuItem.find( 'a[href="#' + id + '"]' ).text() + '' );
            }
        } else {
            $sidebarNavMobile.find( '.nav-toggle' ).text('Jump To');
        }
    }
    
    function registerWaypoints() {
        var $section = $('.quicknav_section');
        $section.each( function() {
            var id = $(this).prev('.quicknav_anchor').attr('id');
            $( this ).waypoint( {
                handler: function ( direction ) {
                    if ( 'down' === direction ) {
                        highlightMenuItem( id );
                    }
                },
                offset: '120px'
            } );
            $( this ).waypoint( {
                handler: function ( direction ) {
                    if ( 'up' === direction ) {
                        highlightMenuItem( id );
                    }
                },
                offset: '-120%'
            } );
        } );
    }
});

( function( $, window ) {
    'use strict';

    $( function() {
        var $waypoint = $( '.js-waypoint' );
        var waypointVisible = 'is-visible';

        if ( window.matchMedia( '(min-width: 768px)' ).matches ) {
            $waypoint.each( function() {
                $( this ).waypoint( {
                    handler: function() {
                        $( this.element ).addClass( waypointVisible );
                        this.destroy();
                    },
                    offset: '85%'
                } );
            } );
        } else {
            $waypoint.addClass( waypointVisible );
        }
    } );
} )( jQuery, window );

( function( $, document, window ) {
    'use strict';

    $( function() {
        var $trigger = $( '.js-primary-menu-submenu-trigger' );
        var $dropdown = $( '.js-primary-menu-dropdown' );
        var $submenu = $( '.js-primary-menu-submenu' );
        var $list = $( '.js-primary-menu-list' );

        $trigger.on( 'mouseenter', function() {
            $( this ).closest( $submenu ).addClass( 'is-active' );
            if ( $( this ).hasClass( 'primary-menu-submenu__item--two-columns' ) ) {
                $( this ).closest( $submenu ).addClass( 'is-active--two-columns' );
            }
            $( this ).closest( $list ).first().css( 'min-height', $( this ).find( $list ).first().height() + 'px' );
        } ).on( 'mouseleave', function() {
            $( this ).closest( $submenu ).removeClass( 'is-active' ).removeClass( 'is-active--two-columns' );
            $( this ).closest( $list ).first().css( 'min-height', '' );
        } );
    } );
} )( jQuery, document, window );

( function( $, document, window ) {
    'use strict';

    $( function() {
        var interval = 250;
        var visibleHeight = 800;
        var $body = $( 'body' );
        var activeClass = 'sticky-header--is-active';
        var $header = $( '.js-sticky-header' );
        var didScroll = false;

        var handleScroll = function() {
            var currentScrollTop = ( $( window ).scrollTop() || $( 'body' ).scrollTop() );

            if ( currentScrollTop > visibleHeight ) {
                if ( ! $header.hasClass( activeClass ) ) {
                    $header.addClass( activeClass );
                    $body.addClass( 'has-sticky-header' );
                }
            } else {
                if ( $header.hasClass( activeClass ) ) {
                    $header.removeClass( activeClass );
                    $body.removeClass( 'has-sticky-header' );
                }
            }
        };

        $( window ).on( 'scroll', function() {
            didScroll = true;
        } );

        setInterval( function() {
            if ( didScroll ) {
                handleScroll();
                didScroll = false;
            }
        }, interval );

        $( window ).trigger( 'scroll' );
    } );
} )( jQuery, document, window );

( function( $, window ) {
    'use strict';

    $( function() {
        var activeClass = 'site-offcanvas--is-active';

        var $trigger = $( '.js-site-offcanvas-trigger' );
        var $body = $( '.js-site-offcanvas' );
        var $close = $( '.js-site-offcanvas-close' );

        $trigger.on( 'click', function() {
            $body.addClass( activeClass );
            window.fixBody();
        } );

        $close.on( 'click', function() {
            $body.removeClass( activeClass );
            window.unfixBody();
        } );
    } );
} )( jQuery, window );

( function( $ ) {
    'use strict';

    $( function() {
        var menuActiveClass = 'site-offcanvas--is-active';
        var activeClass = 'is-active';

        var $item = $( '.js-offcanvas-menu-item' );
        var $trigger = $( '.js-offcanvas-menu-trigger' );
        var $submenu = $( '.js-offcanvas-menu-submenu' );
        var $back = $( '.js-site-offcanvas-back' );
        var $body = $( '.js-site-offcanvas' );
        var $close = $( '.js-site-offcanvas-close' );

        $back.removeClass( activeClass );

        // Add heading to each submenu
        $submenu.each( function() {
            var $parentTrigger = $( this ).closest( $item ).find( $trigger ).first();
            var title = $parentTrigger.text().trim();
            var href = $parentTrigger.attr( 'href' );
            $( this ).prepend( '<a href="' + href + '" class="offcanvas-menu-submenu__title  js-offcanvas-menu-submenu-title">' + title + '</a>' );
        } );

        $trigger.on( 'click', function( event ) {
            event.preventDefault();
            $( this ).parent().find( $submenu ).first().addClass( activeClass );
            $back.addClass( activeClass );
        } );

        $back.on( 'click', function() {
            $submenu.filter( '.' + activeClass ).last().removeClass( activeClass );

            if ( $submenu.filter( '.' + activeClass ).length === 0 ) {
                $back.removeClass( activeClass );
            }
        } );

        $item.children().filter( 'a' ).not( $trigger ).on( 'click', function() {
            $body.removeClass( menuActiveClass );
            window.unfixBody();
        } );
    } );
} )( jQuery );

( function ( $ ) {
    'use strict';

    // Document ready
    $( function () {
        // Select all links with hashes
        $( 'a[href*="#"]' )
            // Remove links that don't actually link to anything
            .not( '[href="#"]' )
            .not( '[href="#0"]' )
            .not( '.jsJumpSectionLink' )
            .click( function ( event ) {
                // On-page links
                if (
                    location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' )
                    &&
                    location.hostname === this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $( this.hash );
                    target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) + ']' );
                    // Does a scroll target exist?
                    if ( target.length ) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $( 'html, body' ).animate( {
                            scrollTop: target.offset().top
                        }, 1000, function () {
                            // Callback after animation
                            // Must change focus!
                            var $target = $( target );
                            $target.focus();
                            if ( $target.is( ":focus" ) ) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr( 'tabindex', '-1' ); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }
                        } );
                    }
                }
            } );
    } );
} )( jQuery );
